import React, {useEffect, useState} from "react";
import {
    AuthStudent,
    AuthSuperAdmin, AuthTeacher,
    checkAuth, checkAuths,
    currentUser,
    logout,
} from "../api";
import {Link, useNavigate} from "react-router-dom";
import {Button, Dropdown, Layout, Menu, Modal, Space, Drawer} from "antd";
import LanguageSelectDropdown from "../locales/LanguageSelect";
import {UserOutlined, LogoutOutlined, LockOutlined, MenuOutlined} from "@ant-design/icons";
import {t} from "../locales/locales";
import {navItems} from "../routes/navItems";
import UpdatePasswordModal from "./UpdatePasswordModal";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

const {Header} = Layout;


export default function AppNavbar() {
    const [user, setUser] = useState<any>();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showUpdatePasswordModal, setShowUpdatePasswordModal] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();
    const screens = useBreakpoint(); // 👈 响应式断点

    useEffect(() => {
        const handleRedirectIndex = () => {
            const path = window.location.pathname;
            if (path === "/" || path === "") {
                navigate("/dashboard");
            }
        };

        const handleRedirect = () => {
            const path = window.location.pathname;
            if (path !== "/" && path !== "/index") {
                navigate("/login");
            }
        };

        const handleRedirectToResetInitPassword = () => {
            navigate("/reset-init-password");
        }

        const checkUser = async () => {
            try {
                const result = await currentUser();
                if (result) {
                    setUser(result.data);
                    setIsLoggedIn(true);
                    if (result.data.initPassword !== "") {
                        handleRedirectToResetInitPassword()
                    }
                    handleRedirectIndex();
                } else {
                    handleRedirect();
                }
            } catch (err) {
                setIsLoggedIn(false);
                handleRedirect();
            }
        };


        checkUser().then()
    }, [navigate]);

    const handleLogout = () => {
        logout().then(() => {
            setIsLoggedIn(false);
            navigate("/login");
        });
    };

    // 用户菜单
    const userMenu = (
        <Menu selectable={false} style={{border: "none", boxShadow: "none"}}>
            <Menu.Item key="auth" disabled>
                {user?.name}
            </Menu.Item>

            {checkAuth(user, AuthSuperAdmin) && (
                <>
                    <Menu.Divider/>
                    <Menu.Item key="manager">
                        <Link to="/admin/manager">{t("navbar_to_Management")}</Link>
                    </Menu.Item>
                    <Menu.Item key="filelog">
                        <Link to="/admin/file_log">{t("navbar_to_FileLog")}</Link>
                    </Menu.Item>
                </>
            )}

            <Menu.Divider/>
            <Menu.Item
                key="updatepwd"
                icon={<LockOutlined/>}
                onClick={() => {
                    setShowUpdatePasswordModal(true);
                }}
            >
                {t("navbar_update_password")}
            </Menu.Item>
            <Menu.Item key="logout" icon={<LogoutOutlined/>} onClick={handleLogout}>
                {t("navbar_logout")}
            </Menu.Item>
        </Menu>
    );

    // 手机端抽屉菜单内容
    const mobileMenuContent = (
        <Menu mode="inline" style={{border: "none"}}>
            {navItems.map((item) => (
                checkAuths(user, item.auth) && (
                    <Menu.Item key={item.key} onClick={() => setMobileMenuOpen(false)}>
                        {item.label}
                    </Menu.Item>
                )
            ))}

            {checkAuth(user, AuthSuperAdmin) && (
                <>
                    <Menu.Divider/>
                    <Menu.Item key="manager-mobile" onClick={() => setMobileMenuOpen(false)}>
                        <Link to="/admin/manager">{t("navbar_to_Management")}</Link>
                    </Menu.Item>
                    <Menu.Item key="filelog-mobile" onClick={() => setMobileMenuOpen(false)}>
                        <Link to="/admin/file_log">{t("navbar_to_FileLog")}</Link>
                    </Menu.Item>
                </>
            )}
        </Menu>
    );

    return (
        <>
            {/* 修改密码 Modal */}
            <Modal
                title={t("navbar_update_password_modal_title")}
                open={showUpdatePasswordModal}
                onCancel={() => setShowUpdatePasswordModal(false)}
                footer={null}
                width={560}
            >
                {UpdatePasswordModal(() => setShowUpdatePasswordModal(false))}
            </Modal>

            {/* 手机端抽屉菜单 */}
            <Drawer
                title={t("navbar_menu")}
                placement="right"
                closable={true}
                onClose={() => setMobileMenuOpen(false)}
                open={mobileMenuOpen}
                width={280}
            >
                {mobileMenuContent}
            </Drawer>

            <Header
                style={{
                    backgroundColor: "#ffffff",
                    padding: screens.xs ? "0 16px" : "0 24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "none",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                    height: 64,
                }}
            >
                {/* 左侧 Logo */}
                <Link to="/index" style={{flexShrink: 0}}>
                    <img
                        src={user ? "/UniTop_Logo_2.png" : "/UniTop_Logo_1.png"}
                        alt="UniTop Logo"
                        style={{height: "40px", width: "auto"}}
                    />
                </Link>

                {/* 中间菜单 - 仅在中大屏显示 */}
                {isLoggedIn && screens.md && (
                    <Menu
                        mode="horizontal"
                        style={{
                            flex: 1,
                            marginLeft: 40,
                            borderBottom: "none",
                            minWidth: 0,
                        }}
                        selectable={false}
                    >
                        {navItems.map((item) => (
                            checkAuths(user, item.auth) && (<Menu.Item key={item.key}>{item.label}</Menu.Item>)
                        ))}
                    </Menu>
                )}

                {/* 右侧操作区 */}
                <Space size="middle" style={{display: "flex", alignItems: "center", flexShrink: 0}}>
                    {/* 语言选择 */}
                    <div style={{marginTop: 3}}>
                        <LanguageSelectDropdown/>
                    </div>

                    {/* 登录/用户按钮 */}
                    {!isLoggedIn ? (
                        <Link to="/login">
                            <Button type="default" size="small">
                                {t("navbar_login")}
                            </Button>
                        </Link>
                    ) : (
                        user && (
                            <>
                                {/* 汉堡菜单（仅小屏） */}
                                {!screens.md && (
                                    <Button
                                        type="text"
                                        icon={<MenuOutlined/>}
                                        onClick={() => setMobileMenuOpen(true)}
                                        style={{marginRight: 8}}
                                    />
                                )}

                                {/* 用户下拉 */}
                                <Dropdown overlay={userMenu} placement="bottomRight">
                                    <Button
                                        type="primary"
                                        size="small"
                                        icon={<UserOutlined/>}
                                        style={{backgroundColor: "#e86e2d"}}
                                    >
                                        {screens.xs ? null : user.name} {/* 小屏只显示图标 */}
                                    </Button>
                                </Dropdown>
                            </>
                        )
                    )}
                </Space>
            </Header>
        </>
    );
}